module.exports = __webpack_public_path__ + "static/about-59ef545c765c964b4f812ec8285bd103.jpg";